import {
	TenantContactDto,
	ContactTitleEnum,
} from '@splitsecondconnect/ultramarine-shared';

import { dateCast } from '../functions/sectionCasters.function';

export function mapContactDtoToModel(x: TenantContactDto | null): any {
	if (!x) {
		return {
			contactId: null,
			contactShortName: null,
			contactFullName: null,
			contactFirstName: null,
			contactMiddleNames: null,
			contactLastName: null,
			contactCompanyName: null,
			contactTitle: ContactTitleEnum.NONE,
			contactEmail: null,
			contactAddress1: null,
			contactAddress2: null,
			contactDateOfBirth: null,
			contactCity: null,
			contactPoBox: null,
			contactPostCode: null,
			contactCounty: null,
			contactState: null,
			contactCountryId: null,
			contactPhoneFax: null,
			contactPhoneMobile: null,
			contactPhoneLandline: null,
			contactWebsite: null,
			contactFacebook: null,
			contactInstagram: null,
			contactTwitter_X: null,
			contactSlack: null,
			contactWhatsApp: null,
			contactYoutube: null,
			contactLinkedIn: null,
		};
	}
	return {
		contactId: x.id ?? null,
		contactShortName: x.shortName() ?? null,
		contactFullName: x.fullName() ?? null,
		contactFirstName: x.firstName ?? null,
		contactMiddleNames: x.middleNames ?? null,
		contactLastName: x.lastName ?? null,
		contactCompanyName: x.companyName ?? null,
		contactTitle: x.title ?? null,
		contactEmail: x.email ?? null,
		contactDateOfBirth: dateCast(x.dateOfBirth),
		contactAddress1: x.address1 ?? null,
		contactAddress2: x.address2 ?? null,
		contactCity: x.city ?? null,
		contactPoBox: x.poBox ?? null,
		contactPostCode: x.postCode ?? null,
		contactCounty: x.county ?? null,
		contactState: x.state ?? null,
		contactCountryId: x.countryId ?? null,
		contactPhoneFax: x.phoneFax ?? null,
		contactPhoneMobile: x.phoneMobile ?? null,
		contactPhoneLandline: x.phoneLandline ?? null,
		contactWebsite: x.website ?? null,
		contactFacebook: x.facebook ?? null,
		contactInstagram: x.instagram ?? null,
		contactTwitter_X: x.twitter_x ?? null,
		contactSlack: x.slack ?? null,
		contactWhatsApp: x.whatsApp ?? null,
		contactYoutube: x.youtube ?? null,
		contactLinkedIn: x.linkedIn ?? null,
	};
}

export function mapContactModelToDto(x: any): any {
	return {
		contact: {
			id: x.contactId ?? null,
			firstName: x.contactFirstName ?? null,
			middleNames: x.contactMiddleNames ?? null,
			lastName: x.contactLastName ?? null,
			companyName: x.contactCompanyName ?? null,
			title: x.contactTitle ?? null,
			email: x.contactEmail ?? null,
			address1: x.contactAddress1 ?? null,
			address2: x.contactAddress2 ?? null,
			city: x.contactCity ?? null,
			postCode: x.contactPostCode ?? null,
			poBox: x.contactPoBox ?? null,
			state: x.contactState ?? null,
			county: x.contactCounty ?? null,
			countryId: x.contactCountryId ?? null,
			dateOfBirth: dateCast(x.contactDateOfBirth),
			phoneFax: x.contactPhoneFax ?? null,
			phoneMobile: x.contactPhoneMobile ?? null,
			phoneLandline: x.contactPhoneLandline ?? null,
			website: x.contactWebsite ?? null,
			facebook: x.contactFacebook ?? null,
			instagram: x.contactInstagram ?? null,
			twitter_x: x.contactTwitter_X ?? null,
			slack: x.contactSlack ?? null,
			whatsApp: x.contactWhatsApp ?? null,
			youtube: x.contactYoutube ?? null,
			linkedIn: x.contactLinkedIn ?? null,
		},
	};
}
